import { render, staticRenderFns } from "./Backup.vue?vue&type=template&id=3acd85e5&scoped=true"
import script from "./Backup.vue?vue&type=script&lang=js"
export * from "./Backup.vue?vue&type=script&lang=js"
import style0 from "./Backup.vue?vue&type=style&index=0&id=3acd85e5&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3acd85e5",
  null
  
)

export default component.exports